/*
Copyright (c) Karsten Jeske and John Firth
This source code is licensed under the proprietary license found in the
LICENSE file in the root directory of this source tree.
*/

import { zodResolver } from "@hookform/resolvers/zod"
import {
  CurrentUserParameters,
  currentUserParametersSchema,
} from "features/userParameters/UserParametersSchemata"
import type { Resolver } from "react-hook-form"

// AIDEV-NOTE: The assertion is needed because @hookform/resolvers v5 types zodResolver(schema)
// as Resolver<z.input<schema>, Ctx, z.output<schema>>, with input and output typed separately.
// Nearly every field of the schema goes through z.preprocess, which types its input as
// `unknown`, so the input type is not assignable to the values useForm<CurrentUserParameters>
// expects. The form's values are the schema's output type, which is what this asserts. Letting
// useForm infer instead makes every form value input-shaped, and explicit generics on
// zodResolver do not match an overload. This lives in its own module so test-utils can share it
// without loading UserParametersForm's import graph.
export const userParametersResolver = zodResolver(
  currentUserParametersSchema
) as Resolver<CurrentUserParameters>
